/**
 * Constants for group node type prefixes and separators
 *
 * v1 Prefix + Separator: workflow/
 * v2 Prefix + Separator: workflow> (ComfyUI_frontend v1.2.63)
 */
export const PREFIX = 'workflow'
export const SEPARATOR = '>'
